import { createContext, useContext } from 'react';

import type { ChatMessageBody, IncidentId, PortalHubConnection } from '../realtime';

export type IncidentRealtime = {
  readonly incidentId: IncidentId;
  readonly hub: PortalHubConnection;
  sendChatMessage(body: ChatMessageBody): Promise<void>;
  setChatTranslationsAllowed(allowChatTranslations: boolean): Promise<void>;
  sendDispatcherTextPreview(messagePreview: string): Promise<void>;
  sendDispatcherImagePreview(isSendingImage: boolean): Promise<void>;
  endLiveVideo(): Promise<void>;
  switchCamera(): Promise<void>;
  toggleTorch(): Promise<void>;
  takeCallerCameraSnapshot(): Promise<void>;
};

export function createIncidentRealtime(hub: PortalHubConnection, incidentId: IncidentId): IncidentRealtime {
  return {
    incidentId,
    hub,
    sendChatMessage: (body) => hub.invoke('SendChatMessage', incidentId, body),
    setChatTranslationsAllowed: (allowChatTranslations) =>
      hub.invoke('SetIsChatTranslationsAllowed', incidentId, allowChatTranslations),
    sendDispatcherTextPreview: (messagePreview) =>
      hub.invoke('SendDispatcherChatTextMessagePreview', incidentId, messagePreview),
    sendDispatcherImagePreview: (isSendingImage) =>
      hub.invoke('SendDispatcherChatImageMessagePreview', incidentId, isSendingImage),
    endLiveVideo: () => hub.invoke('EndLiveVideo', incidentId),
    switchCamera: () => hub.invoke('SwitchCameraRequest', incidentId),
    toggleTorch: () => hub.invoke('ToggleTorchRequest', incidentId),
    takeCallerCameraSnapshot: () => hub.invoke('TakeCallerCameraSnapshot', incidentId),
  };
}

export const IncidentRealtimeContext = createContext<IncidentRealtime | null>(null);

export function useIncidentRealtime(): IncidentRealtime | null {
  return useContext(IncidentRealtimeContext);
}
